import React from 'react';
import AdvanceBooking from './AdvanceBooking';
import Invoices from './Invoices';
import MonthlyRental from './MonthlyRental';
import PaymentDataCards from './PaymentDataCards';
import PreviousPayments from './PreviousPayments';
import Subscription from './Subscription';

const Payments = () => {
    return (
        <div className="px-10 py-4">
            <PaymentDataCards/>
            <Subscription/>
            <MonthlyRental/>
            <Invoices/>
            <PreviousPayments/>
            <AdvanceBooking/>
        </div>
    );
}

export default Payments;
